import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { Seo } from '../../../components'
import MainContainer from './MainContainer'

export default function DiscoverPageLayout({ children }) {
  const { t } = useTranslation()

  return (
    <div className='min-h-screen w-full' style={{ backgroundColor: '#EBEFFD' }}>
      <Seo title={t('seo.titles.discover')} />

      <div className='min-h-screen overflow-y-auto pr-80'>
        <MainContainer>
          <div className='flex max-w-[54rem] flex-col'>{children}</div>
        </MainContainer>
      </div>
    </div>
  )
}

DiscoverPageLayout.propTypes = {
  children: PropTypes.node.isRequired
}
